import { Component, OnInit } from '@angular/core';
import { ProveedorService } from '@app/core/service/proveedor.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CrearProveedorComponent } from './crear-proveedor/crear-proveedor.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-proveedores',
  templateUrl: './proveedores.component.html',
  styleUrls: ['./proveedores.component.css']
})
export class ProveedoresComponent implements OnInit {
  proveedores: any;

  constructor(
    private proveedorService: ProveedorService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.listaProveedores('');
  }

  listaProveedores(term: string) {
    this.proveedorService.getAll().subscribe(data => {
      this.proveedores = data.data;
    });
  }

  create() {
    const modalRef = this.modalService.open(CrearProveedorComponent, {
      size: 'lg'
    });
    modalRef.componentInstance.title = 'Nuevo Proveedor';
    modalRef.result.then(result => {
      if (result) {
        this.listaProveedores('');
      }
    });
  }

  editar(id: any) {
    const modalRef = this.modalService.open(CrearProveedorComponent, {
      size: 'lg'
    });
    modalRef.componentInstance.title = 'Editar Proveedor';
    modalRef.componentInstance.estado = true;
    modalRef.componentInstance.id = id;

    modalRef.result.then(result => {
      if (result) {
        this.listaProveedores('');
      }
    });
  }

  estado(event: any, checked: any, id: any) {
    this.proveedorService.enableCategory(id).subscribe(data => {
      Swal.fire(data.success);
      this.listaProveedores('');
    });
  }

  eliminar(id: string) {
    Swal.fire({
      title: 'Esta seguro de Eliminar al proveedor?',
      text: 'Una vez eliminado, Ud no podra recuperar el registro eliminado!',
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true
    }).then(willDelete => {
      if (willDelete.value) {
        this.proveedorService.delete(id).subscribe(x => {
          this.listaProveedores('');
        });
        Swal.fire('Se elimino correctamente');
      } else {
        Swal.fire('No se pudo eliminar');
      }

      console.log(willDelete);
    });
  }
}
